import 'yet-another-react-lightbox/styles.css'
import './index.css'

import { Toaster } from '@/components/ui/sonner'
import LoginDialog from '@/components/LoginDialog'
import { useAtomValue, useSetAtom } from 'jotai'
import { PageManager } from './PageManager'
import { useEffect } from 'react'
import { primaryColorAtom, themeAtom } from './atoms/theme'
import { PRIMARY_COLORS } from './constants'
import { loginDialogOpenAtom } from '@/atoms/session'

export default function App(): JSX.Element {
  const theme = useAtomValue(themeAtom)
  const primaryColor = useAtomValue(primaryColorAtom)
  const loginDialogOpen = useAtomValue(loginDialogOpenAtom)
  const setLoginDialogOpen = useSetAtom(loginDialogOpenAtom)

  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(theme)
  }, [theme])

  useEffect(() => {
    const root = document.documentElement
    const config = PRIMARY_COLORS[primaryColor] ?? PRIMARY_COLORS.DEFAULT
    const colors = theme === 'light' ? config.light : config.dark

    root.style.setProperty('--primary', colors.primary)
    root.style.setProperty('--primary-hover', colors['primary-hover'])
    root.style.setProperty('--primary-foreground', colors['primary-foreground'])
    root.style.setProperty('--ring', colors.ring)
  }, [theme, primaryColor])

  return (
    <>
      <PageManager />
      <Toaster />
      <LoginDialog open={loginDialogOpen} setOpen={setLoginDialogOpen} />
    </>
  )
}
